export { default as BannerLocation } from './BannerLocation';
